<template>
  <div class="social-responsibility">
    <div class="banner">
      <img src="../../assets/img/socialResponsibility/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("socialResponsibility.banner.bannerTitle")}}</h1>
          <p>{{$t("socialResponsibility.banner.bannerP")}}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="environmental-protection" id="environmental">
        <div class="headline">
          <h1>{{$t("socialResponsibility.environmentalProtection.headlineTitle")}}</h1>
          <p>{{$t("socialResponsibility.environmentalProtection.headlineP")}}</p>
        </div>
        <el-row :gutter="60">
          <el-col :span="10" :xs="24">           
            <p>{{ $t("socialResponsibility.environmentalProtection.des.text1") }}</p>
            <p>{{ $t("socialResponsibility.environmentalProtection.des.text2") }}</p>
          </el-col>
          <el-col :span="14" :xs="24" >
            <div class="pic">
              <img src="../../assets/img/socialResponsibility/huanjing.jpg" />
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="scienceAndTechnologyInnovate" id="science">
        <div class="headline">
          <h1>{{$t("socialResponsibility.scienceAndTechnologyInnovate.headlineTitle")}}</h1>
          <p>{{$t("socialResponsibility.scienceAndTechnologyInnovate.headlineP")}}</p>
        </div>
        <el-row :gutter="60">
          <el-col :span="14" :xs="24">
            <div class="pic">
              <img src="../../assets/img/socialResponsibility/keji.jpg" />
            </div>
          </el-col>
          <el-col :span="10" :xs="24" >           
            <p>{{ $t("socialResponsibility.scienceAndTechnologyInnovate.des.text1") }}</p>
            <p>{{ $t("socialResponsibility.scienceAndTechnologyInnovate.des.text2") }}</p>
          </el-col>
        </el-row>
      </div>

      <div class="socialGood" id="socialGood">
        <div class="headline">
          <h1>{{$t("socialResponsibility.socialGood.headlineTitle")}}</h1>
          <p>{{$t("socialResponsibility.socialGood.headlineP")}}</p>
        </div>
        <el-row :gutter="60">
          <el-col :span="12"  :xs="24">
            <div class="pic">
              <img src="../../assets/img/socialResponsibility/heilongjiang.png" />
            </div>
          </el-col>
          <el-col :span="12"  :xs="24">     
            <h2>{{ $t("socialResponsibility.socialGood.des.title") }}</h2>      
            <p>{{ $t("socialResponsibility.socialGood.des.text1") }}</p>
            <p>{{ $t("socialResponsibility.socialGood.des.text2") }}</p>
          </el-col>
        </el-row>
        <el-row :gutter="60" class="row2">
          <el-col :span="12"  :xs="24">   
            <h2>{{ $t("socialResponsibility.socialGood.des2.title") }}</h2>              
            <p>{{ $t("socialResponsibility.socialGood.des2.text1") }}</p>
          </el-col>
          <el-col :span="12"  :xs="24">
            <div class="pic">
              <img src="../../assets/img/socialResponsibility/yilang.png" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "SocialResponsibility",
  data() {
    return {

    };
  },
  mounted() {
    
    var options = { live: false };
    new this.$wow.WOW(options).init();

    const partId=this.$route.query.part;

    if(partId){
      this.$nextTick(()=>{
        document.querySelector("#"+partId).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      })
    }
    
  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
$cblue: #0054A7;
.social-responsibility{
  .el-row{
    p{
      text-align: justify;
    }
  }
  .banner{
    .banner-text{
      // background: linear-gradient(to right, #025192, #0f8250);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
      color:#0f8250
    }
  }
  .environmental-protection,.scienceAndTechnologyInnovate{
    p+p{
      margin-top:40px;
    }
  }
  .socialGood{
    .row2{
      margin-top:40px;
    }

    h2{
      &::after{
        content: "";
        display: block;
        width:54px;
        height: 6px;
        background:$cblue;
        margin-top:20px;
      }
    }
    p{
      margin-top:20px;
    }
    
  }
    @media screen and (max-width:768px){
      .socialGood{
        h2{
          font-size:18px;
        }
      }
    }
}

</style>
